<script lang="ts">
	import SeoAreaSelector from "./SeoAreaSelector.svelte";
	import SeoFooter from "./SeoFooter.svelte";

	export let data: any;
</script>

<article>
	<h1 class="display-l">{data.page.heading}</h1>
	<p class="body-l">
		Last updated: &nbsp; 
		{new Date(1713942565 * 1000).toLocaleString('en-US', { weekday: 'short', day: 'numeric', month: 'long', year: 'numeric' })}
	</p>
	<br>
	{@html data.page.contentHtml}
</article>

<SeoAreaSelector areas={data.parentAreas} />

<!-- <SeoFooter appstores={data.apps.stores} socials={data.social} tallogo={data.tallogo}/> -->